import { useCallback, useEffect, useState } from "react";
import {
    crearPresupuesto,
    actualizarPresupuesto,
    obtenerEjecucionPresupuesto,
    eliminarPresupuesto,
} from "../api/presupuestoApi";

function normalizarPresupuesto(row) {
    return {
        idPresupuesto: row.id_presupuesto,
        anio: row.anio,
        mes: row.mes,
        idCategoria: row.id_categoria,
        idSubcategoria: row.id_subcategoria,
        categoriaNombre: row.categoriaNombre ?? "",
        montoAsignado: Number(row.monto_asignado || 0),
        montoEjecutado: Number(row.ejecutado_real || 0),
        porcentajeAlerta: Number(row.porcentaje_alerta || 80),
        estado: row.estado,
    };
}

export default function usePresupuestos() {
    const [presupuestos, setPresupuestos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtros, setFiltros] = useState({ anio: "", mes: "" });

    const cargar = useCallback(async () => {
        setLoading(true);
        try {
            const ejec = await obtenerEjecucionPresupuesto(filtros);
            const lista = Array.isArray(ejec) ? ejec.map(normalizarPresupuesto) : [];
            setPresupuestos(lista);
        } catch (error) {
            console.error("Error cargando presupuestos:", error);
            setPresupuestos([]);
        } finally {
            setLoading(false);
        }
    }, [filtros]);

    useEffect(() => {
        cargar();
    }, [cargar]);

    const guardar = async (payload, id) => {
        if (id) {
            await actualizarPresupuesto(id, payload);
        } else {
            await crearPresupuesto(payload);
        }
        await cargar();
    };

    const eliminar = async (id) => {
        await eliminarPresupuesto(id);
        await cargar();
    };

    return {
        presupuestos,
        loading,
        filtros,
        setFiltros,
        cargar,
        guardar,
        eliminar,
    };
}